<template>
  <span>
    {{ humanFileSize }}
  </span>
</template>

<script type="text/javascript">

export default {
  name: "HumanFilesizeComponent",
  props: {
    bytes: {
      required: true,
    }
  },
  computed: {
    humanFileSize() {
      let thresh = 1024,
          dp = 1,
          bytes = this.bytes;

      if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
      }

      const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let u = -1;
      const r = 10 ** dp;

      do {
        bytes /= thresh;
        ++u;
      } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


      return bytes.toFixed(dp) + ' ' + units[u];
    }
  }
}
</script>
